export const computeParcelas = (total, manual) => {
  const t = Math.round((parseFloat(total) || 0) * 100);
  const n = manual.length;
  const vals = Array(n).fill(0);
  const manualIdx = [];
  const autoIdx = [];
  manual.forEach((v, i) => {
    if (v !== "" && v !== null && v !== undefined) {
      vals[i] = Math.round((parseFloat(v) || 0) * 100);
      manualIdx.push(i);
    } else autoIdx.push(i);
  });
  const rest = t - manualIdx.reduce((s, i) => s + vals[i], 0);
  if (autoIdx.length) {
    const base = Math.floor(rest / autoIdx.length);
    autoIdx.forEach((i) => { vals[i] = base; });
    vals[autoIdx[autoIdx.length - 1]] = rest - base * (autoIdx.length - 1);
  }
  return vals.map((c) => c / 100);
};

export const somaParcelas = (vals) =>
  Math.round(vals.reduce((s, v) => s + Math.round(v * 100), 0)) / 100;
